<!--<template>-->
<!--  <div class="tinymce-boxz">-->
<!--    <Editor ref="tinyMCEEditor" v-model="content" :api-key="tiny.apiKey" :init="tiny.init"/>-->
<!--  </div>-->

<!--  &lt;!&ndash;  <button @click="handleChangeHtml">替换内容</button>&ndash;&gt;-->
<!--  &lt;!&ndash;  <button @click="exportHtml">生成html</button>&ndash;&gt;-->
<!--  &lt;!&ndash;  <div >{{targetHtml}}</div>&ndash;&gt;-->
<!--</template>-->

<!--<script>-->
<!--import {defineComponent, defineAsyncComponent, ref, reactive, onMounted} from 'vue'-->
<!--import Editor from "@tinymce/tinymce-vue";-->
<!--import {requestDefaultSendTemplate} from "@/api/mail";-->
<!--import {ElMessage} from "element-plus";-->

<!--export default defineComponent({-->
<!--  components: {-->
<!--    Editor-->
<!--  },-->
<!--  setup() {-->
<!--    const content = ref("");-->
<!--    const tiny = reactive({-->
<!--      apiKey: "4vkc5gp566t61a7mk9owocb2jmay6a8xis5zfrguncwp8zu4", //https://www.tiny.cloud/auth/signup/(获取key链接，要记得自己申请)-->
<!--      init: {-->
<!--        language: "zh_CN", //语言类型-->
<!--        placeholder: "在这里输入文字", //textarea中的提示信息-->
<!--        min_width: 320,-->
<!--        min_height: 220,-->
<!--        height: 500, //注：引入autoresize插件时，此属性失效-->
<!--        resize: "both", //编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号-->
<!--        branding: true, //tiny技术支持信息是否显示-->
<!--        // statusbar: false,  //最下方的元素路径和字数统计那一栏是否显示-->
<!--        // elementpath: false, //元素路径是否显示-->
<!--        draggable_modal: true,-->
<!--        fullscreen_native: true,-->
<!--        menubar: false,//菜单栏配置-->
<!--        paste_remove_styles: false,//移除粘贴内容的样式-->
<!--        paste_remove_styles_if_webkit: false, //webkit 不清楚样式-->
<!--        paste_as_text: false,  // Ensure pasted content is not stripped down to plain text-->
<!--        paste_enable_default_filters: false,-->
<!--        paste_data_images: true, //图片是否可粘贴-->
<!--        // menubar: "file edit my1", //菜单栏配置，设为false则隐藏，不配置则默认显示全部菜单，也可自定义配置&#45;&#45;查看 http://tinymce.ax-z.cn/configure/editor-appearance.php &#45;&#45;搜索“自定义菜单”-->
<!--        plugins: 'preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media' +-->
<!--            ' code codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount' +-->
<!--            ' autosave autoresize accordion',//插件配置，因为一些功能需要插件-->
<!--        toolbar: ['undo redo fontfamily fontsize forecolor backcolor bold italic underline removeformat lineheight outdent indent alignleft aligncenter alignright alignjustify image media table charmap bullist numlist code fullscreen preview formatpainter'],-->
<!--        // images_upload_url: '/apib/api-upload/uploadimg',  //后端处理程序的url，建议直接自定义上传函数image_upload_handler，这个就可以不用了-->
<!--        // images_upload_base_path: '/demo',  //相对基本路径&#45;&#45;关于图片上传建议查看&#45;&#45;http://tinymce.ax-z.cn/general/upload-images.php-->
<!--        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',-->
<!--        font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',-->
<!--        file_picker_types: "image", //file image media分别对应三个类型文件的上传：link插件，image和axupimgs插件，media插件。想屏蔽某个插件的上传就去掉对应的参数-->
<!--        // 文件上传处理函数-->
<!--        automatic_uploads: false,-->
<!--        images_upload_handler(blobInfo, success, failure) {-->
<!--          return new Promise((resolve, reject) => {-->
<!--            console.log(blobInfo.base64())-->
<!--            resolve('data:' + blobInfo.blob().type + ';base64,' + blobInfo.base64());-->
<!--          })-->
<!--        },-->
<!--        // 提前插入默认模版-->
<!--        init_instance_callback: async function (editor) {-->
<!--          await getDefaultEmailTemplate()-->
<!--          // Insert initial content-->
<!--          editor.setContent(insertHtml.value);-->
<!--        }-->
<!--      }-->
<!--    })-->

<!--    const tinyMCEEditor = ref(null)-->
<!--    const insertHtml = ref(``)-->

<!--    async function getDefaultEmailTemplate() {-->
<!--      const result = await requestDefaultSendTemplate();-->
<!--      if (result.code !== 200) {-->
<!--        ElMessage.error(result.message);-->
<!--        return;-->
<!--      }-->
<!--      // editorTarget.value.cmd.do('insertHTML', )-->
<!--      console.log('result.result?.textContent', result)-->
<!--      if (result.result) {-->
<!--        insertHtml.value = result.result?.textContent-->
<!--      }-->
<!--    }-->

<!--    const handleChangeHtml = () => {-->
<!--      console.log('ffff', tinyMCEEditor.value.getEditor())-->
<!--      const editor = tinyMCEEditor.value?.getEditor();-->
<!--      if (editor) {-->
<!--        // Clear all content-->
<!--        editor.resetContent();-->

<!--        // Set new content-->
<!--        editor.setContent('<p>This is the new content!</p>');-->
<!--      }-->
<!--    }-->

<!--    const targetHtml = ref("")-->
<!--    const exportHtml = () => {-->
<!--      const editor = tinyMCEEditor.value?.getEditor();-->
<!--      if (editor) {-->
<!--        // Clear all content-->
<!--        targetHtml.value = editor.getContent();-->
<!--      }-->
<!--    }-->
<!--    return {-->
<!--      targetHtml,-->
<!--      exportHtml,-->
<!--      tinyMCEEditor,-->
<!--      handleChangeHtml,-->
<!--      content,-->
<!--      tiny-->
<!--    }-->
<!--  },-->
<!--})-->
<!--</script>-->

<!--<style lang="less" scoped>-->
<!--:deep(.tox-statusbar) {-->
<!--  display: none !important;-->
<!--}-->
<!--</style>-->

<!--<template>-->
<!--&lt;!&ndash;  <TinyEditor :editorId="'template'"></TinyEditor>&ndash;&gt;-->
<!--  <TinyEditor ref="tinyEditorTemplate" :width="'100%'" :initial-content="tinyEditorTemplateContentHtml"-->
<!--              :editorId="'template'"></TinyEditor>-->
<!--</template>-->
<!--<script setup>-->
<!--import {ref} from "vue";-->
<!--const tinyEditorTemplateContentHtml  = ref("<div>dddddddd</div>")-->
<!--// import TinyEditor from "@/components/TinyEditor/ElSelectLoading.vue";-->
<!--import TinyEditor from "@/components/TinyEditor/ElSelectLoading.vue";-->
<!--</script>-->


<!--<template>-->
<!--  <div class="input-container">-->
<!--    <el-input v-model="input1" placeholder="请输入" />-->
<!--    <el-input v-model="input2" placeholder="请输入" />-->
<!--    <el-input v-model="input3" placeholder="请输入" />-->
<!--    <el-input v-model="input4" placeholder="请输入" />-->
<!--  </div>-->

<!--  <div class="table-wrapper">-->
<!--    <el-table :data="tableData" border style="width: 100%">-->
<!--      <el-table-column prop="date" label="Date" width="20vw" />-->
<!--      <el-table-column prop="name" label="Name" width="20vw" />-->
<!--      <el-table-column prop="address" label="Address" />-->
<!--    </el-table>-->
<!--  </div>-->
<!--  &lt;!&ndash;  <Pagination></Pagination>&ndash;&gt;-->
<!--  &lt;!&ndash;  <div class="Drag2">&ndash;&gt;-->
<!--  &lt;!&ndash;    <div class="box" ref="box">&ndash;&gt;-->
<!--  &lt;!&ndash;      &lt;!&ndash;      <div class="left">&ndash;&gt;&ndash;&gt;-->
<!--  &lt;!&ndash;      &lt;!&ndash;        &lt;!&ndash;左侧div内容&ndash;&gt;&ndash;&gt;&ndash;&gt;-->
<!--  &lt;!&ndash;      &lt;!&ndash;      </div>&ndash;&gt;&ndash;&gt;-->
<!--  &lt;!&ndash;      &lt;!&ndash;      <div class="resize" title="左右侧边栏">⋮</div>&ndash;&gt;&ndash;&gt;-->
<!--  &lt;!&ndash;      <div class="mid">&ndash;&gt;-->
<!--  &lt;!&ndash;        &lt;!&ndash;右侧div内容&ndash;&gt;&ndash;&gt;-->

<!--  &lt;!&ndash;        <div class="topBox">&ndash;&gt;-->
<!--  &lt;!&ndash;          &lt;!&ndash;右上div内容&ndash;&gt;&ndash;&gt;-->
<!--  &lt;!&ndash;        </div>&ndash;&gt;-->
<!--  &lt;!&ndash;        <div title="移动到边界进行位置调整" class="move">⋯</div>&ndash;&gt;-->
<!--  &lt;!&ndash;        <div class="downBox">&ndash;&gt;-->
<!--  &lt;!&ndash;          &lt;!&ndash;右下div内容&ndash;&gt;&ndash;&gt;-->
<!--  &lt;!&ndash;          <iframe ref="pageframe" id="pageframe"&ndash;&gt;-->
<!--  &lt;!&ndash;                  :srcdoc="content"&ndash;&gt;-->
<!--  &lt;!&ndash;                  :style="{width: '100%',height: '100%'}"&ndash;&gt;-->
<!--  &lt;!&ndash;          >&ndash;&gt;-->
<!--  &lt;!&ndash;            <p>Your browser does not support preview features, please download Google browser or other modern&ndash;&gt;-->
<!--  &lt;!&ndash;              browsers.</p>&ndash;&gt;-->
<!--  &lt;!&ndash;          </iframe>&ndash;&gt;-->
<!--  &lt;!&ndash;        </div>&ndash;&gt;-->
<!--  &lt;!&ndash;      </div>&ndash;&gt;-->
<!--  &lt;!&ndash;    </div>&ndash;&gt;-->
<!--  &lt;!&ndash;  </div>&ndash;&gt;-->
<!--</template>-->


<!--<script setup>-->
<!--import {onMounted, ref} from "vue";-->
<!--import AIDeepLoading from "@/components/AI/AIDeepLoading.vue";-->
<!--import Pagination from "@/components/Pagination/indexEdm.vue"-->
<!--import TopSearch from "@/views/Customer/TopComponents/TopSearch.vue";-->

<!--const input1 = ref('')-->
<!--const input2 = ref('')-->
<!--const input3 = ref('')-->
<!--const input4 = ref('')-->

<!--onMounted(() => {-->
<!--  dragControllerUD();-->
<!--});-->

<!--const content = ref(`<div dir=\\"ltr\\">Dear Zoe <div><br></div><div>Thank you </div><div><br></div><div>Here is attached </div><div><br></div><div>Best regards </div></div><br><div class=\\"gmail_quote gmail_quote_container\\"><div dir=\\"ltr\\" class=\\"gmail_attr\\">2024년 12월 25일 (수) 오후 6:55, &lt;<a href=\\"mailto:zoe@gpemotor.com\\">zoe@gpemotor.com</a>&gt;님이 작성:<br></div><blockquote class=\\"gmail_quote\\" style=\\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\\"><div><div><span style=\\"font-size:14px\\"><span style=\\"font-family:arial\\">Dear Jaemin<br><br>Payment is received, thanks, we&#39;ll prepare production asap, estimated delivery time would be around end of February, will keep in touch if any update.<br><br>Best regards</span></span><br> \\r\\n<table border=\\"0\\" cellpadding=\\"0\\" cellspacing=\\"0\\" style=\\"color:rgb(0,0,0);font-family:Helvetica,Arial,sans-serif;font-size:medium;height:140.074px;width:703px\\" width=\\"703\\">\\r\\n<tbody>\\r\\n<tr style=\\"width:770px;height:140.074px\\" valign=\\"top\\">\\r\\n<td style=\\"border-right-style:solid;border-right-color:rgb(141,141,141);width:126.986px;padding-right:10px\\"><img src=\\"http://cdn.mail-talk.com/d232b40911924d-20241225094403.png\\" width=\\"126\\" height=\\"132\\" alt=\\"\\"></td>\\r\\n<td style=\\"padding-left:10px;font-stretch:normal;width:553.284px\\">\\r\\n<div><span style=\\"font-size:14px;font-family:arial\\"><span style=\\"font-size:14px;color:rgb(31,73,125)\\"><span style=\\"color:rgb(100,100,100)\\"><strong><span>Zoe Chen</span></strong></span><br><span style=\\"color:rgb(141,141,141)\\">Sales Engineer - GP Technology Group / Jigu Motor Technology Co.,Ltd</span><br><span style=\\"color:rgb(141,141,141)\\">Panhuoqiao Villiage, Zhonghe Street, Yinzhou, Ningbo, Zhejiang, China, 315105</span></span></span></div>\\r\\n<div style=\\"padding:5px 0px\\"><span style=\\"font-size:14px;font-family:arial\\"><span style=\\"color:rgb(68,140,187);display:inline-block\\">P:</span><span style=\\"color:rgb(31,73,125)\\"> +86 0574 8770 4085  | </span><span style=\\"color:rgb(68,140,187);display:inline-block\\">M:</span><span style=\\"color:rgb(68,140,187);font-size:14px\\"> </span><span style=\\"color:rgb(31,73,125)\\">+86 18074213538 (Wechat/WhatsApp)</span><br><span style=\\"color:rgb(31,73,125);display:inline-block\\"><span style=\\"color:rgb(144,205,231)\\"><span style=\\"color:rgb(68,140,187)\\">E:</span> </span></span><span style=\\"color:rgb(31,73,125)\\"><a href=\\"mailto:zoe@gpemotor.com\\" target=\\"_blank\\">zoe@gpemotor.com</a> (Skype) </span><span style=\\"color:rgb(31,73,125)\\">| </span><span style=\\"white-space:nowrap;display:inline-block\\"><span style=\\"color:rgb(68,140,187)\\">W:</span><span style=\\"color:rgb(31,73,125)\\"> </span><u style=\\"color:rgb(31,73,125);font-size:14px\\"><a href=\\"http://www.gpemotor.com\\" target=\\"_blank\\">www.gpemotor.com</a></u><span style=\\"color:rgb(31,73,125)\\">   </span></span></span></div>\\r\\n<div style=\\"font-size:13px;font-family:Arial;color:rgb(141,141,141);padding:5px 0px\\"><span style=\\"font-size:14px;font-family:arial\\"><strong><span style=\\"font-size:14px;color:rgb(31,73,125)\\"><span style=\\"color:rgb(144,205,231)\\"><span style=\\"color:rgb(68,140,187)\\">Manufacturer of Custom Electric Motors and Fans.</span></span></span></strong></span></div>\\r\\n</td>\\r\\n</tr>\\r\\n</tbody>\\r\\n</table>\\r\\n</div>\\r\\n<p><br><br></p>\\r\\n<div></div>\\r\\n<div style=\\"font-size:12px;background:rgb(245,245,245);padding:8px;color:rgb(68,68,68)\\">\\r\\n<div>\\r\\n<div style=\\"font-size:12px;font-family:&quot;Arial Narrow&quot;;padding:2px 0px\\">&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; Original Message &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</div>\\r\\n<b>From:</b> <a href=\\"mailto:thepyos2@gmail.com\\" target=\\"_blank\\">thepyos2@gmail.com</a></div>\\r\\n<div><b>Date:</b> 2024-12-24 19:16:36</div>\\r\\n<div><b>To:</b> <a href=\\"mailto:zoe@gpemotor.com\\" target=\\"_blank\\">zoe@gpemotor.com</a></div>\\r\\n<div><b>Subject:</b> Re:Re: Re: About purchase | GPI241219</div>\\r\\n</div>\\r\\n<div></div>\\r\\n<div>Dear Zoe \\r\\n<div></div>\\r\\n<div>Ok </div>\\r\\n<div></div>\\r\\n<div>I will make a payment soon </div>\\r\\n<div></div>\\r\\n<div>Best regards </div>\\r\\n</div>\\r\\n<p></p>\\r\\n<div>\\r\\n<div>2024년 12월 19일 (목) 오후 2:15, &lt;<a href=\\"mailto:zoe@gpemotor.com\\" target=\\"_blank\\">zoe@gpemotor.com</a>&gt;님이 작성:</div>\\r\\n<blockquote class=\\"gmail_quote\\" style=\\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\\">\\r\\n<div>\\r\\n<p style=\\"text-align:left\\"><span style=\\"font-size:14px\\"><span style=\\"font-family:arial\\">Dear Jaemin<br><br>Quantity in PI is changed, please check.<br><br>Best regards<br><br></span></span></p>\\r\\n<table border=\\"1\\" style=\\"border-collapse:collapse;width:55.577%;border-width:1px;border-style:hidden\\"><colgroup><col style=\\"width:20.4745%\\"><col style=\\"width:79.5259%\\"></colgroup>\\r\\n<tbody>\\r\\n<tr>\\r\\n<td><img src=\\"http://cdn.mail-talk.com/759e67c7e85f40-20241025095947.png\\" width=\\"140\\" height=\\"147\\" alt=\\"\\"></td>\\r\\n<td>\\r\\n<div><span style=\\"font-size:14px;font-family:Calibri;color:rgb(31,73,125)\\"><span style=\\"font-family:Arial;color:rgb(100,100,100)\\"><strong><span>  Zoe Chen<br></span></strong></span><span style=\\"color:rgb(141,141,141);font-family:Arial\\">  Sales Engineer - GP Technology Group / Jigu Motor Technology Co.,Ltd</span><br><span style=\\"color:rgb(141,141,141);font-family:Arial\\">  Panhuoqiao Villiage, Zhonghe Street, Yinzhou, Ningbo, Zhejiang, China, 315105</span></span></div>\\r\\n<div style=\\"padding:5px 0px\\"><span style=\\"font-size:14px\\"><span><span style=\\"color:rgb(68,140,187);font-family:Calibri;display:inline-block\\">  P:</span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\"> +86 0574 8770 4085  | </span><span style=\\"color:rgb(68,140,187);font-family:Calibri;display:inline-block\\">M:</span><span style=\\"color:rgb(68,140,187);font-family:Calibri;font-size:14px\\"> </span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\">+86 18074213538 (Wechat/WhatsApp)</span><br><span style=\\"color:rgb(31,73,125);font-family:Calibri;display:inline-block\\"><span style=\\"color:rgb(144,205,231)\\"><span style=\\"color:rgb(68,140,187)\\">  E:</span> </span></span><span style=\\"color:rgb(31,73,125);font-family:arial\\"><a href=\\"mailto:zoe@gpemotor.com\\" rel=\\"noopener\\" target=\\"_blank\\">zoe@gpemotor.com</a> (Skype) </span></span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\">| </span><span style=\\"white-space:nowrap;display:inline-block\\"><span style=\\"color:rgb(68,140,187);font-family:Calibri\\">W:</span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\"> </span><u style=\\"color:rgb(31,73,125);font-family:Calibri;font-size:14px\\"><a href=\\"http://www.gpemotor.com\\" rel=\\"noopener\\" target=\\"_blank\\">www.gpemotor.com</a></u><span style=\\"color:rgb(31,73,125);font-family:Calibri\\">   </span></span></span></div>\\r\\n<div style=\\"font-size:13px;font-family:Arial;color:rgb(141,141,141);padding:5px 0px\\"><strong><span style=\\"font-size:14px;font-family:Calibri;color:rgb(31,73,125)\\"><span style=\\"color:rgb(68,140,187)\\">  Manufacturer of Custom Electric Motors and Fans.</span></span></strong></div>\\r\\n</td>\\r\\n</tr>\\r\\n</tbody>\\r\\n</table>\\r\\n<p><br><br></p>\\r\\n<div></div>\\r\\n<div style=\\"font-size:12px;background:rgb(245,245,245);padding:8px;color:rgb(68,68,68)\\">\\r\\n<div>\\r\\n<div style=\\"font-size:12px;font-family:&quot;Arial Narrow&quot;;padding:2px 0px\\">&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; Original Message &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</div>\\r\\n<b>From:</b> <a href=\\"mailto:thepyos2@gmail.com\\" rel=\\"noopener\\" target=\\"_blank\\">thepyos2@gmail.com</a></div>\\r\\n<div><b>Date:</b> 2024-12-19 12:25:05</div>\\r\\n<div><b>To:</b> <a href=\\"mailto:zoe@gpemotor.com\\" rel=\\"noopener\\" target=\\"_blank\\">zoe@gpemotor.com</a></div>\\r\\n<div><b>Subject:</b> Re:Re: About purchase | GPI241219</div>\\r\\n</div>\\r\\n<div></div>\\r\\n<div>Dear Zoe \\r\\n<div></div>\\r\\n<div>Here is attached </div>\\r\\n<div></div>\\r\\n<div>Best regards </div>\\r\\n</div>\\r\\n<p></p>\\r\\n<div>\\r\\n<div>2024년 12월 19일 (목) 오후 1:17, jeamin Pyo &lt;<a href=\\"mailto:thepyos2@gmail.com\\" rel=\\"noopener\\" target=\\"_blank\\">thepyos2@gmail.com</a>&gt;님이 작성:</div>\\r\\n<blockquote class=\\"gmail_quote\\" style=\\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\\">\\r\\n<div>Dear Zoe \\r\\n<div></div>\\r\\n<div>According to your attached </div>\\r\\n<div></div>\\r\\n<div>Connectors are 30EA, I would like to place an order 50EA</div>\\r\\n<div></div>\\r\\n<div>Pls, kindly revised it </div>\\r\\n<div></div>\\r\\n<div>Best regards</div>\\r\\n</div>\\r\\n<br>\\r\\n<div>\\r\\n<div>2024년 12월 19일 (목) 오전 11:20, &lt;<a href=\\"mailto:zoe@gpemotor.com\\" rel=\\"noopener\\" target=\\"_blank\\">zoe@gpemotor.com</a>&gt;님이 작성:</div>\\r\\n<blockquote class=\\"gmail_quote\\" style=\\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\\">\\r\\n<div>\\r\\n<p style=\\"text-align:left\\"><span style=\\"font-size:14px\\"><span style=\\"font-family:arial\\"><span style=\\"font-family:arial\\">Dear Jaemin<br><br>Good day<br><br>PI is attached, please check, delivery time would be around 45 workdays, it comes to the end of year, so may be impacted by Chinese New Year holidays, kindly confirm.</span><br><br>Best regards<br><br></span></span></p>\\r\\n<table border=\\"1\\" style=\\"border-collapse:collapse;width:55.577%;border-width:1px;border-style:hidden\\"><colgroup><col style=\\"width:20.4745%\\"><col style=\\"width:79.5259%\\"></colgroup>\\r\\n<tbody>\\r\\n<tr>\\r\\n<td><img src=\\"http://cdn.mail-talk.com/759e67c7e85f40-20241025095947.png\\" width=\\"140\\" height=\\"147\\" alt=\\"\\"></td>\\r\\n<td>\\r\\n<div><span style=\\"font-size:14px;font-family:Calibri;color:rgb(31,73,125)\\"><span style=\\"font-family:Arial;color:rgb(100,100,100)\\"><strong><span>  Zoe Chen<br></span></strong></span><span style=\\"color:rgb(141,141,141);font-family:Arial\\">  Sales Engineer - GP Technology Group / Jigu Motor Technology Co.,Ltd</span><br><span style=\\"color:rgb(141,141,141);font-family:Arial\\">  Panhuoqiao Villiage, Zhonghe Street, Yinzhou, Ningbo, Zhejiang, China, 315105</span></span></div>\\r\\n<div style=\\"padding:5px 0px\\"><span style=\\"font-size:14px\\"><span><span style=\\"color:rgb(68,140,187);font-family:Calibri;display:inline-block\\">  P:</span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\"> +86 0574 8770 4085  | </span><span style=\\"color:rgb(68,140,187);font-family:Calibri;display:inline-block\\">M:</span><span style=\\"color:rgb(68,140,187);font-family:Calibri;font-size:14px\\"> </span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\">+86 18074213538 (Wechat/WhatsApp)</span><br><span style=\\"color:rgb(31,73,125);font-family:Calibri;display:inline-block\\"><span style=\\"color:rgb(144,205,231)\\"><span style=\\"color:rgb(68,140,187)\\">  E:</span> </span></span><span style=\\"color:rgb(31,73,125);font-family:arial\\"><a href=\\"mailto:zoe@gpemotor.com\\" rel=\\"noopener\\" target=\\"_blank\\">zoe@gpemotor.com</a> (Skype) </span></span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\">| </span><span style=\\"white-space:nowrap;display:inline-block\\"><span style=\\"color:rgb(68,140,187);font-family:Calibri\\">W:</span><span style=\\"color:rgb(31,73,125);font-family:Calibri\\"> </span><u style=\\"color:rgb(31,73,125);font-family:Calibri;font-size:14px\\"><a href=\\"http://www.gpemotor.com\\" rel=\\"noopener\\" target=\\"_blank\\">www.gpemotor.com</a></u><span style=\\"color:rgb(31,73,125);font-family:Calibri\\">   </span></span></span></div>\\r\\n<div style=\\"font-size:13px;font-family:Arial;color:rgb(141,141,141);padding:5px 0px\\"><strong><span style=\\"font-size:14px;font-family:Calibri;color:rgb(31,73,125)\\"><span style=\\"color:rgb(68,140,187)\\">  Manufacturer of Custom Electric Motors and Fans.</span></span></strong></div>\\r\\n</td>\\r\\n</tr>\\r\\n</tbody>\\r\\n</table>\\r\\n<p><br><br></p>\\r\\n<div></div>\\r\\n<div style=\\"font-size:12px;background:rgb(245,245,245);padding:8px;color:rgb(68,68,68)\\">\\r\\n<div>\\r\\n<div style=\\"font-size:12px;font-family:&quot;Arial Narrow&quot;;padding:2px 0px\\">&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; Original Message &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</div>\\r\\n<b>From:</b> <a href=\\"mailto:thepyos2@gmail.com\\" rel=\\"noopener\\" target=\\"_blank\\">thepyos2@gmail.com</a></div>\\r\\n<div><b>Date:</b> 2024-12-19 08:34:03</div>\\r\\n<div><b>To:</b> <a href=\\"mailto:zoe@gpemotor.com\\" rel=\\"noopener\\" target=\\"_blank\\">zoe@gpemotor.com</a></div>\\r\\n<div><b>Subject:</b> Re:About purchase</div>\\r\\n</div>\\r\\n<div></div>\\r\\n<div>Dear Zoe \\r\\n<div></div>\\r\\n<div>Hello Zoe </div>\\r\\n<div></div>\\r\\n<div>How have you been? </div>\\r\\n<div></div>\\r\\n<div>I would like to purchase like below </div>\\r\\n<div></div>\\r\\n<div>RG1300 </div>\\r\\n<div></div>\\r\\n<div>Connector </div>\\r\\n<div></div>\\r\\n<div>Each 50EA </div>\\r\\n<div></div>\\r\\n<div>Could you make a quotation? </div>\\r\\n<div></div>\\r\\n<div>Best Regards</div>\\r\\n</div>\\r\\n</div>\\r\\n</blockquote>\\r\\n</div>\\r\\n</blockquote>\\r\\n</div>\\r\\n</div>\\r\\n</blockquote>\\r\\n</div><img src=\\"https://api.mail-talk.com/mailTalk/front/mail/emailCallback?varchar1=1871745105115803649\\"></div></blockquote></div>\\r\\n\\r\\n`)-->

<!--// 上下拖动事件-->
<!--function dragControllerUD() {-->
<!--  var resize = document.getElementsByClassName("move");-->
<!--  var topBox = document.getElementsByClassName("topBox");-->
<!--  var downBox = document.getElementsByClassName("downBox");-->
<!--  var box = document.getElementsByClassName("mid");-->
<!--  console.log(document.getElementsByClassName("move"));-->
<!--  for (let i = 0; i < resize.length; i++) {-->
<!--    // 鼠标按下事件-->
<!--    resize[i].onmousedown = function (e) {-->
<!--      console.log(resize[i].top);-->
<!--      //颜色改变提醒-->
<!--      resize[i].style.background = "#818181";-->
<!--      var startY = e.clientY;-->
<!--      resize[i].top = resize[i].offsetTop;-->
<!--      // 鼠标拖动事件-->
<!--      document.onmousemove = function (e) {-->
<!--        var endY = e.clientY;-->
<!--        var moveLen = resize[i].top + (endY - startY); // （endY - startY）=移动的距离。resize[i].top+移动的距离=上边区域最后的高度-->
<!--        var maxT = box[i].clientHeight - resize[i].offsetHeight; // 容器高度 - 上边区域的高度 = 下边区域的高度-->

<!--        if (moveLen < 50) moveLen = 50; // 上边区域的最小高度为50px-->
<!--        if (moveLen > maxT - 150) moveLen = maxT - 150; //下边区域最小高度为150px-->

<!--        resize[i].style.top = moveLen; // 设置上边区域的高度-->

<!--        for (let j = 0; j < topBox.length; j++) {-->
<!--          topBox[j].style.height = moveLen + "px";-->
<!--          downBox[j].style.height = box[i].clientHeight - moveLen - 10 + "px";-->
<!--        }-->
<!--      };-->
<!--      // 鼠标松开事件-->
<!--      document.onmouseup = function () {-->
<!--        //颜色恢复-->
<!--        resize[i].style.background = "#d6d6d6";-->
<!--        document.onmousemove = null;-->
<!--        document.onmouseup = null;-->
<!--        resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉-->
<!--      };-->
<!--      resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获-->
<!--      return false;-->
<!--    };-->
<!--  }-->
<!--}-->

<!--const tableData = ref([-->
<!--  { date: '2024-04-01', name: 'Tom', address: 'No. 1 Some Street' },-->
<!--  { date: '2024-04-02', name: 'Jerry', address: 'No. 2 Other Street' },-->
<!--])-->
<!--</script>-->
<!--<style lang="less" scoped>-->
<!--.input-container {-->
<!--  display: flex;-->
<!--  justify-content: flex-start;-->
<!--  padding: 1vw;-->
<!--  box-sizing: border-box;-->
<!--  gap: 1vw;-->
<!--}-->

<!--.input-container :deep(.el-input) {-->
<!--  width: 18vw;          /* 视口宽度 25% - gap */-->
<!--  height: 2vw;          /* 高度随宽度缩放 */-->
<!--  font-size: 1.2vw;     /* 字体也按比例缩放 */-->
<!--}-->

<!--/* 调整 el-input 内部 input 的高度和字体 */-->
<!--.input-container :deep(.el-input__inner) {-->
<!--  height: 100% !important;-->
<!--  font-size: inherit;-->
<!--}-->

<!--.table-wrapper {-->
<!--  width: 100vw;-->
<!--  padding: 1vw;-->
<!--  box-sizing: border-box;-->
<!--  overflow-x: auto; /* 小屏时可以横向滚动 */-->
<!--}-->

<!--/* 设置字体和单元格高度按比例缩放 */-->
<!--.table-wrapper :deep(.el-table) {-->
<!--  font-size: 1vw;-->
<!--}-->

<!--.table-wrapper :deep(.el-table__header),-->
<!--.table-wrapper :deep(.el-table__body) {-->
<!--  line-height: 3vw;-->
<!--}-->

<!--.table-wrapper :deep(.el-table__cell) {-->
<!--  padding: 1vw;-->
<!--}-->

<!--</style>-->

<template>
  <div class="out_box">
    <div class="top_box">
      <img src="@/assets/logo.png" class="logoImg"/>
    </div>
    <div class="right_box"></div>
    <iframe
        id="iframeId"
        src="https://www.yuque.com/siyueyinghuasuhuangyan/kgmkzs/ze5mmhg9xfctfv85?singleDoc# 《Mailtalk快速入门指南》"
        style="width: 100vw; height: 100vh; border: none;"
    ></iframe>
  </div>
  <!--        <EmailEcharts-->
  <!--            title="邮件统计"-->
  <!--            type="bar"-->
  <!--            height="300px"-->
  <!--        />-->
  <!--    <EmailReplayEcharts/>-->
  <!--    <CustomerAddEcharts></CustomerAddEcharts>-->
  <!--    <CustomerOriginEcharts></CustomerOriginEcharts>-->
  <!--    <CustomerLevelEcharts></CustomerLevelEcharts>-->
  <!--    <CustomerCountryEcharts></CustomerCountryEcharts>-->
</template>

<script setup>
import EmailEcharts from '@/views/Home/components/EmailEcharts.vue';
import EmailReplayEcharts from "@/views/Home/components/EmailReplayEcharts.vue";
import CustomerAddEcharts from "@/views/Home/components/CustomerAddEcharts.vue";
import CustomerOriginEcharts from "@/views/Home/components/CustomerOriginEcharts.vue";
import CustomerLevelEcharts from "@/views/Home/components/CustomerLevelEcharts.vue";
import CustomerCountryEcharts from "@/views/Home/components/CustomerCountryEcharts.vue";
import {onMounted} from "vue";

</script>
<style lang="less" scoped>
.out_box {
  position: relative;

  .top_box {
    width: 100vw;
    height: 51px;
    background: white;
    position: absolute;
    top: 0px;
    left: 0px;
  }

  .right_box {
    width: 58px;
    height: 124px;
    background: white;
    position: absolute;
    bottom: 68px;
    right: 16px;
  }

  .logoImg {
    height: 30px;
    margin-top: 15px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
